import error from "./Error";

const AccessControl = {
  ...error,
};

export default AccessControl;
